import { createClient } from '@supabase/supabase-js';
import { Database } from './types';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Supabase URL ou chave anônima não definidas nas variáveis de ambiente.');
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce'
  },
  realtime: {
    params: {
      // Padrão do supabase-js. Estava em 2 desde a importação inicial do
      // projeto, cinco vezes abaixo do padrão: ao ultrapassar a média, o
      // servidor Realtime fecha o canal com "Too many messages per second" e
      // o cliente precisa reingressar — é nessa janela que as notificações de
      // chat chegavam atrasadas ou simplesmente não chegavam.
      eventsPerSecond: 10
    }
  },
  db: {
    schema: 'public'
  }
});

/**
 * Cliente Supabase isolado, sem sessão persistida, para operações de auth
 * (ex.: supabase.auth.signUp) que precisam acontecer sem afetar a sessão
 * logada do usuário atual. Usar o cliente `supabase` principal para signUp
 * troca a sessão ativa para o usuário recém-criado e dispara eventos de
 * onAuthStateChange que remontam a árvore autenticada do app (AuthContext /
 * ProtectedLayout), derrubando o estado local de qualquer tela aberta —
 * mesmo que a sessão original seja restaurada logo em seguida com setSession.
 */
export const createIsolatedAuthClient = () =>
  createClient<Database>(supabaseUrl, supabaseAnonKey, {
    auth: {
      autoRefreshToken: false,
      persistSession: false,
      detectSessionInUrl: false,
      // Chave de storage própria: sem isso, o GoTrueClient isolado ainda
      // compartilha estado interno (cache, canal de broadcast) com o cliente
      // principal por usarem a mesma storageKey padrão, mesmo com
      // persistSession desligado — foi exatamente essa a causa dos eventos
      // de onAuthStateChange disparando no cliente principal durante o
      // signUp de um novo usuário.
      storageKey: 'sb-isolated-signup-auth-token'
    }
  });